import { INGXLoggerMonitor, INGXLoggerMetadata } from 'ngx-logger';
import { HeLogHttpService } from '@app/core/async-services/http';
import { firstValueFrom } from 'rxjs';

export class HttpLogMonitor implements INGXLoggerMonitor {
  httpLogger: HeLogHttpService;
  constructor(httpLogger: HeLogHttpService) {
    this.httpLogger = httpLogger;
  }
  onLog(logObject: INGXLoggerMetadata) {
    firstValueFrom(this.httpLogger.logEvent(logObject)).catch(console.error);
  }
}
